export const Achievements = <const>{
  FootMeasurement: 'footMeasurement',
  FootMeasurementAndExtraBonus: 'footMeasurementAndExtraBonus',
  CreateArtwork: 'createArtwork',
  PublishedGallery: 'publishedGallery',
  CreateArtworkAndPublishedGallery: 'createArtworkAndPublishedGallery',
  Birthday: 'birthday',
  RegisterShoes: 'registerShoes',
};

export type Achievements = (typeof Achievements)[keyof typeof Achievements];
